import { render, staticRenderFns } from "./FavouriteMusicFiles.vue?vue&type=template&id=23ba8fac&"
import script from "./FavouriteMusicFiles.vue?vue&type=script&lang=js&"
export * from "./FavouriteMusicFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports